import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ModalLayout from "../../layout/ModalLayout.tsx";
import NewApplicationForm from "../formik/NewApplicationForm.tsx";
export default function NewApplicationModal({ show, onClose, data }) {
    return (_jsx(_Fragment, { children: show && (_jsx(ModalLayout, { title: "Add new application", text: "Add a new application to your project", onClose: onClose, children: _jsx(NewApplicationForm, { onClose: onClose, data: data }) })) }));
}
